import React from 'react'

const Top = () => {
    return (
        <div className=' relative overflow-hidden h-[50px] bg-black'>
            <p className=' text-white uppercase absolute w-full h-full m-0 text-center translate-x-1/2 leading-[50px] animate-marquee '>MADE By Amorntep.</p>
        </div>
    )
}

export default Top